import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Spin, Col, Row, Tag } from 'antd';

import ReactEcharts from '../../Echarts/Echarts';
import StyledTable from "../../../../../commons/styles/table";
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { heatmapCartesionTableMock } from '../../../Mock/heatmapMock';
import { config } from '../../constant';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const HeatmapCartesion = (props) => {

    const [option, setOption] = useState({});
    const [loading, setLoading] = useState(false);
    const [refreshDateTime, setRefreshDateTime] = useState(moment());
    const [errorInAPI, setErrorInAPI] = useState(false);
    const [noDataInDB, setNoDataInDB] = useState(false);
    const [columns, setColumns] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [json, setJson] = useState({});
    const [xAxisList, setxAxisList] = useState();
    const [yAxisList, setyAxisList] = useState();

    let timeTicket = useRef(null);
    const requestCheck = useRef(true);
    const abortController = useRef(new window.AbortController());

    const {
        graphprops,
        selectionDate,
        selectionMonth,
        DeviceCode,
        selectionDateRange,
        dayMonthYear,
        selectedThemeing,
        currentTimeZone,
    } = props;

    useEffect(() => {
        if (timeTicket.current) {
            clearInterval(timeTicket.current);
        }
        let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
        timeTicket.current = setInterval(() => {
            if (requestCheck.current) {
                getData(props, selectedThemeing);
            }
        }, refreshTime);
        return () => {
            abortController.current.abort();
            clearInterval(timeTicket.current);
        };
    }, []);

    useEffect(() => {
        getData(props);
    }, [
        selectionDate,
        selectionMonth,
        selectionDateRange,
        DeviceCode,
        dayMonthYear
    ]);


    useEffect(() => {
        return () => {
              abortController.current.abort();
            clearInterval(timeTicket);
        };
    });

    const updateData = async (data) => {
        try {
            //columns = [];
            let { graphprops } = props;
            let dataSource = [];
            let columnConfig =
                graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].columns
                    ? JSON.parse(graphprops[graphprops.graph].columns)
                    : [];

            let columnsList = [];

            if (columnConfig && Array.isArray(columnConfig)) {
                columnsList = columnConfig.map((column) => {
                    if (column.isUTC && column.isUTC === true) {
                        data = data.map((dataa) => {
                            let date = moment.utc(dataa[column.key]).toDate();
                            return {
                                ...dataa,
                                [column.key]: moment(date).local().format('YYYY-MM-DD HH:mm:ss')
                            };
                        });
                    }
                    return {
                        title: column.title,
                        dataIndex: column.key,
                        key: column.key,
                        render: (text, record) => (
                            <span style={{ color: record.Color }}>
                                {column &&
                                    column.showColor &&
                                    column.showColor === true &&
                                    record[`${column.key}_Color`] ? (
                                    <Tag color={record[`${column.key}_Color`]} key={column.key}>
                                        {text}
                                    </Tag>
                                ) : (
                                    text
                                )}
                            </span>
                        )
                    };
                });
            }
            data.map((dataval) => {
                dataSource.push(dataval);
                return {};
            });
            let columnsData = [];
            if (data && data.length > 0) {
                let datavalues = Object.keys(data[0]);
                columnsData = datavalues.map((item) => {
                    return {
                        title: item,
                        dataIndex: item,
                        key: item
                    };
                });
                setColumns(columnsData);
            }
            let col = [...columnsData, ...columnsList];
            let duplicateColumns = col.filter(
                (ele, ind) => ind === col.findIndex((elem) => elem.title === ele.title)
            );
            setColumns(duplicateColumns);
            setDataSource(dataSource);
        } catch (e) {
            setColumns([]);
            setDataSource([]);
        }
    };

    const removeDuplicateObjectsByKey = (array, fieldToDuplicateCheck) => {
        const newArray = [];
        const arrayKeys = [];
        array.forEach((item) => {
            if (!arrayKeys.includes(item[fieldToDuplicateCheck])) {
                arrayKeys.push(item[fieldToDuplicateCheck]);
                newArray.push(item);
            }
        });
        return newArray;
    };
    const getOption = () => {
        let option = {
            tooltip: {
                position: 'top'
            },
            grid: {
                height: '50%',
                top: '10%'
            },
            xAxis: {
                type: 'category',
                data: [],
                splitArea: {
                    show: true
                }
            },
            yAxis: {
                type: 'category',
                data: [],
                splitArea: {
                    show: true
                }
            },
            visualMap: {
                // min: 0,
                // max: 10,
                // calculable: true,
                orient: 'horizontal',
                left: 'center',
                bottom: '15%'
            },
            series: [
                {
                    name: '',
                    type: 'heatmap',
                    data: [],
                    label: {
                        show: true
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        return option;
    };
    const getData = async () => {
        setErrorInAPI(false);
        setNoDataInDB(false);
        const { graphprops } = props;
        let json = {};
        let option = getOption();
        setLoading(true);
        if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
            json = heatmapCartesionTableMock;
            requestCheck.current = true;
        } else {
            if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
                json = graphprops.currentDateData;
            } else {
                if (
                    graphprops &&
                    ((graphprops.DashboardLevelSelection === 'datePicker' ||
                        graphprops.GraphLevelSelection === 'datePicker') &&
                        selectionDate) ||
                    (
                        (graphprops.DashboardLevelSelection === 'monthPicker' ||
                            graphprops.GraphLevelSelection === 'monthPicker') &&
                        selectionMonth) ||
                    (
                        (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
                            graphprops.GraphLevelSelection === 'dateRangePicker') &&
                        selectionDateRange) ||
                    (
                        (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
                            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
                        dayMonthYear) ||
                    (
                        (graphprops.DashboardLevelSelection === 'deviceSelection' ||
                            graphprops.GraphLevelSelection === 'deviceSelection') &&
                        DeviceCode)
                ) {
                    json = await getChartDataWithSelection({
                        graphprops,
                        selectionDate,
                        selectionMonth,
                        selectionDateRange,
                        DeviceCode,
                        dayMonthYear,
                        abortController: abortController.current,
                        currentTimeZone,
                    });
                    requestCheck.current = true;
                } else if (
                    graphprops.GraphLevelSelection === 'none' ||
                    graphprops.DashboardLevelSelection === 'none'
                ) {
                    json = await getChartDataWithoutSelection({
                        graphprops,
                        abortController: abortController.current,
                        DeviceCode,
                        TimeZone: currentTimeZone,
                    });
                    requestCheck.current = true;
                }
            }
        }
        // json = [
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Name",
        //       "Value": "MRS0011_Accident",
        //       "Action": []
        //     },
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Count",
        //       "Value": 0.05,
        //       "Description": "Accident",
        //       "Action": []
        //     },
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Name",
        //       "Value": "MRS0011_Delay",
        //       "Action": []
        //     },
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Count",
        //       "Value": 0.28,
        //       "Description": "Delay",
        //       "Action": []
        //     },
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Name",
        //       "Value": "MRS0011_Immobilization",
        //       "Action": []
        //     },
        //     {
        //       "DateTime": "MRS0011",
        //       "Name": "Count",
        //       "Value": 0.27,
        //       "Description": "Immobilization",
        //       "Action": []
        //     }
        //   ]
        let xAxisList = [];
        let yAxisList = [];
        if (
            (json && json.message) ||
            (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
        ) {
            if (json.message) {
                setErrorInAPI(true);
            } else if (json.length === 0) {
                setNoDataInDB(true);
            }
        } else {
            xAxisList = removeDuplicateObjectsByKey(json, 'DateTime');
            yAxisList = removeDuplicateObjectsByKey(json, 'Description');

            option.xAxis.data = xAxisList.map((xAx) => {
                return xAx.DateTime;
            });
            option.yAxis.data = yAxisList.map((yAx) => {
                return yAx.Description;
            });

            // option.series[0].data = [[0, 0, 123], [0, 1, 124], [1, 0, 456], [1, 1, 567]]
            let list = [];
            yAxisList &&
                Array.isArray(yAxisList) &&
                yAxisList.map((yAxis, yIndex) => {
                    xAxisList.map((xAxis, xIndex) => {
                        let filterObj = json.filter(
                            (axis) => axis.Description === yAxis.Description && axis.DateTime === xAxis.DateTime
                        );
                        list.push([
                            xIndex,
                            yIndex,
                            filterObj && filterObj[0] && filterObj[0].Value ? filterObj[0].Value : null || '-'
                        ]);
                        return {};
                    });
                    return {};
                });
            option.series[0].data = list;
            setOption(option);
            setRefreshDateTime(moment());
            setJson(json);
        }
        setErrorInAPI(errorInAPI);
        setNoDataInDB(noDataInDB);
        setxAxisList(xAxisList);
        setyAxisList(yAxisList);

    };
    const onChartClick = (cellData) => {
        let selectedName = xAxisList[cellData.data[0]].DateTime;
        let selectedDescription = yAxisList[cellData.data[1]].Description;
        let filterObj = json.filter(
            (axis) => axis.Description === selectedDescription && axis.DateTime === selectedName
        );
        if (filterObj && filterObj[0] && filterObj[0].Action) {
            updateData(filterObj[0].Action);
        } else {
            updateData([]);
        }
    };

    let onEvents = {
        click: (cellData) => onChartClick(cellData)
    };
    return (
        <span>
            {loading === false ? (
                <Fragment>
                    <Tag color="blue" style={{ float: "", position: "relative", zIndex: "2" }} >
                        {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm') : ""}
                    </Tag>
                    {noDataInDB === true || errorInAPI === true ? (
                        noDataInDB === true ? (
                            <NoRecordComponent />
                        ) : (
                            <ErrorComponent />
                        )
                    ) : (
                        <>
                            {loading === false ? (
                                <div style={{ padding: '0px' }}>
                                    <Row>
                                        <Col span={22}>
                                            {noDataInDB === true || errorInAPI === true ? (
                                                noDataInDB === true ? (
                                                    <NoRecordComponent />
                                                ) : (
                                                    <ErrorComponent />
                                                )
                                            ) : (
                                                <ReactEcharts
                                                    option={option}
                                                    className="react_for_echarts"
                                                    style={{ height: '360px', width: '100%' }}
                                                    onEvents={onEvents}
                                                />
                                            )}
                                        </Col>
                                        <Col span={24}>
                                            <div>
                                                {columns && Array.isArray(columns) && columns.length > 0 ? (
                                                    <StyledTable size="small"
                                                        style={{ padding: '20px' }}
                                                        showSorterTooltip={false}
                                                        columns={columns && Array.isArray(columns) ? columns : []}
                                                        dataSource={dataSource.map((data, index) => ({ ...data, key: index }))}
                                                        pagination={{ pageSize: '5' }}
                                                    />
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        textAlign: 'center',
                                        color: 'white',
                                        marginTop: '15%'
                                    }}
                                >
                                    <h2 style={{ color: 'white' }}>
                                        <Spin spinning={loading} tip="Loading..." ></Spin>
                                    </h2>
                                </div>
                            )}
                        </>
                    )}
                </Fragment>
            ) : null}
        </span>
    );
};




const mapStateToProps = (state) => {
    return {
        translationCache: state.TranslationReducer.translationCache,
        currentTimeZone: state.LayoutReducer.currentTimeZone,
        selectedThemeing: state.ThemeReducer.themeing
    };
};

export default connect(mapStateToProps)(HeatmapCartesion);
